module.exports = __webpack_public_path__ + "img/IMG_2671_L_WoodMatted.c872d1d9.jpg";